/*
 *
 * FulfillmentNoteDetailPage constants
 *
 */

enum ActionTypes {
  DEFAULT_ACTION = 'app/FulfillmentNoteDetailPage/DEFAULT_ACTION',
  FETCH_FULFILLMENT_NOTE_REQUEST = 'app/FulfillmentNoteDetailPage/FETCH_FULFILLMENT_NOTE_REQUEST',
  FETCH_FULFILLMENT_NOTE_SUCCESS = 'app/FulfillmentNoteDetailPage/FETCH_FULFILLMENT_NOTE_SUCCESS',
  FETCH_FULFILLMENT_NOTE_FAILURE = 'app/FulfillmentNoteDetailPage/FETCH_FULFILLMENT_NOTE_FAILURE',
  BULK_REORDER = 'app/FulfillmentNoteDetailPage/BULK_REORDER',
  BULK_REORDER_REQUEST = 'app/FulfillmentNoteDetailPage/BULK_REORDER_REQUEST',
  BULK_REORDER_SUCCESS = 'app/FulfillmentNoteDetailPage/BULK_REORDER_SUCCESS',
  BULK_REORDER_FAILURE = 'app/FulfillmentNoteDetailPage/BULK_REORDER_FAILURE',
  RATE = 'app/FulfillmentNoteDetailPage/RATE',
  RATE_REQUEST = 'app/FulfillmentNoteDetailPage/RATE_REQUEST',
  RATE_SUCCESS = 'app/FulfillmentNoteDetailPage/RATE_SUCCESS',
  RATE_FAILURE = 'app/FulfillmentNoteDetailPage/RATE_FAILURE',
  RATING_MODAL_OPEN = 'app/FulfillmentNoteDetailPage/RATING_MODAL_OPEN',
  RATING_MODAL_CLOSE = 'app/FulfillmentNoteDetailPage/RATING_MODAL_CLOSE',

  DOWNLOAD_DELIVERY_NOTE = 'app/FulfillmentNoteDetailPage/DOWNLOAD_DELIVERY_NOTE',
}

export default ActionTypes;
